import React from 'react';

import styles from './index.module.scss';

export interface WaveformProps {
  progress: number; // 0-100
  isPlaying?: boolean;
  className?: string;
}

const waveformHeights = [
  2.2, 8.8, 15.4, 4.4, 17.6, 15.4, 11, 11, 11, 15.4, 11, 17.6, 11, 4.4, 4.4, 11, 16, 17.6,
  11, 4.4,
];

const waveformBars = waveformHeights.map((height, i) => {
  const barWidth = 2.2;
  const spacing = 4;
  const x = i * (barWidth + spacing);
  const y = (20 - height) / 2;

  return { x, y, height, id: i };
});

const Waveform: React.FC<WaveformProps> = ({
  progress,
  isPlaying = false,
  className = '',
}) => {
  return (
    <div className={`${styles.waveform} ${className}`}>
      <svg
        width="125"
        height="20"
        viewBox="0 0 125 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {waveformBars.map((bar, index) => {
          const fillColor = isPlaying ? '#4931FA' : '#A0AAF8';

          return (
            <rect
              key={bar.id}
              x={bar.x}
              y={bar.y}
              width="2.2"
              height={bar.height}
              rx="1.1"
              fill={fillColor}
              className={isPlaying ? styles.waveAnimation : ''}
              style={{
                animationDelay: `${index * 0.05}s`,
                transition: 'fill 0.2s ease-out',
              }}
            />
          );
        })}
      </svg>
    </div>
  );
};

export default Waveform;
